import React from "react"
import { Button } from "react-bootstrap";
import Web3 from 'web3';

// Deposit Native Tokens
// Lockbox instance (this.state.lockbox) is passed into to props as props.lockbox
// Address of sender (this.state.address) is passed into props as props.address
function DepositNativeTab(props) {

    const handleDepositNative = (event) => {
        event.preventDefault();
        if (event.target.amount.value <= 0) {
          alert("Can't deposit " + event.target.amount.value + " tokens!");
        }
        else {
          submitDepositNative(event.target.category.value, event.target.amount.value);
        }
    }

    // this is not correct: hard coded as native deposit of ether
    const submitDepositNative = async (category, amount) => {
        await props.lockbox.methods.depositNative(category).send({ from: props.address, value: Web3.utils.toWei(amount, "ether") });
    }

    return (
        <form onSubmit={handleDepositNative}>
            <label>Category</label>
            <br />
            <input type="text" name="category" className="form-control w-25 center-block"></input>
            <br />
            <label>Deposit Amount</label>
            <br />
            <input type="number" step="0.000001" min="0" name="amount" className="form-control w-25 center-block"></input>
            <br />
            <br />
            <Button variant="dark" type="submit">Submit Deposit</Button>
        </form>
    )
}

export default DepositNativeTab
